import React from 'react';

import { Box } from '@chakra-ui/react';
import { clearReloadFeedbackList } from 'actions/continuousFeedback';
import { setHelloBarCount } from 'actions/hellobar';
import { connect, useSelector, useDispatch } from 'react-redux';
import { selectReviewHelloBar } from 'selectors/hellobar';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { StyledGrid } from 'styles/common';
import { checkFeedbackModuleEnabled } from 'utils/helpers/moduleAccess';

import { HELLO_BAR_PAGE_TYPE, HELLO_BAR_PAGE_TYPE_2 } from 'constants/ProjectConstants';

import { putHelloBarDetails } from 'services/notifications';
import { showErrorSnackbar } from 'services/snackbar';

import ActiveReviews from './ActiveReviews';
import ArchivedReviews from './ArchivedReviews';
import ContinuousFeedback from './ContinuousFeedback';
import HelloBar from './HelloBar';
import PerformanceReviewGraph from './PerformanceReviewGraph';

const Container = styled.div`
  padding: 1rem 2rem;
`;

const LandingPage = ({ loggedInEmployee, continuousFeedback }) => {
  const reviewHelloBar = useSelector(selectReviewHelloBar);
  const dispatch = useDispatch();

  const clearReloadType = () => {
    dispatch(clearReloadFeedbackList());
  };

  const { reloadType, reloadStats } = continuousFeedback;

  const crossPendingReviewsHelloBar = () => {
    putHelloBarDetails({ pageType: HELLO_BAR_PAGE_TYPE.REVIEW })
      .then(() => {
        dispatch(setHelloBarCount({ param: HELLO_BAR_PAGE_TYPE_2.REVIEW, value: null }));
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'Something went wrong.'));
        console.error(err);
      });
  };

  return (
    <>
      {reviewHelloBar.count ? (
        <HelloBar
          message={`You have ${reviewHelloBar.count} pending reviews.`}
          handleClose={crossPendingReviewsHelloBar}
        />
      ) : null}
      <Container>
        <StyledGrid container xs={12} bottomGutter={4}>
          <Box flex={2}>
            <PerformanceReviewGraph />
          </Box>
          {checkFeedbackModuleEnabled() && (
            <Box flex={1} marginLeft="2rem">
              <ContinuousFeedback reloadStats={reloadStats} />
            </Box>
          )}
        </StyledGrid>
        <ActiveReviews reloadType={reloadType} clearReloadType={clearReloadType} loggedInEmployee={loggedInEmployee} />
        <ArchivedReviews
          reloadType={reloadType}
          clearReloadType={clearReloadType}
          loggedInEmployee={loggedInEmployee}
        />
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  loggedInEmployee: selectLoggedInEmployeeData(state),
  continuousFeedback: state.continuousFeedback,
});

export default connect(mapStateToProps, {})(LandingPage);
